import { Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AppStateProvider } from './components/AppStateProvider/AppStateProvider';
import Header from './components/Header/Header';
import { MainContent } from './components/MainContent/MainContent';
import { LogoDialectica } from './icons/LogoDialectica';

const AppContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: `calc(100% - ${theme.brandSidebarWidth}px)`,
  height: '100%',
  background: theme.backgroundColor,
  overflow: 'hidden',
  [theme.breakpoints.between('md', 1280)]: {
    width: `calc(100% - ${theme.tabletBrandSidebarWidth}px)`,
  },
  [theme.breakpoints.down('sm') + theme.includeLandscapeMd]: {
    width: '100%',
    overflowY: 'auto',
  },
}));

const BrandSidebar = styled('div')(({ theme }) => ({
  background: '#06033A',
  position: 'fixed',
  top: 0,
  bottom: 0,
  right: 0,
  left: `calc(100% - ${theme.brandSidebarWidth}px)`,
  '& svg': {
    position: 'absolute',
    right: 0,
    bottom: 40,
  },
  [theme.breakpoints.between('md', 1280)]: {
    left: `calc(100% - ${theme.tabletBrandSidebarWidth}px)`,
  },
  [theme.breakpoints.down('sm') + theme.includeLandscapeMd]: {
    display: 'none',
  },
}));

function App() {
  return (
    <AppStateProvider>
      <AppContainer>
        <Header />
        <MainContent />
        <BrandSidebar>
          <LogoDialectica />
        </BrandSidebar>
      </AppContainer>
    </AppStateProvider>
  );
}

export default App;
